exports.BASE_URL = "https://d1dy7csbdbvymr.cloudfront.net/"

exports.COVER_PHOTO = "website-artifacts/coverPhoto.webp"
exports.BANNER = "website-artifacts/banner.webp"